//node modules
import { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import AOS from "aos";
import "aos/dist/aos.css";

//Components
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import WhatIsDigicall from "./components/WhatIsDigicall";
import UnileverDigitalTeam from "./components/UnileverDigitalTeam";
import WhoCanApply from "./components/WhoCanApply";
import Process from "./components/Process";
import Program from "./components/Program";
import Faq from "./components/Faq";
import Register from "./components/Register";
import Footer from "./components/Footer";
import CookieAnn from "./components/CookieAnn";
import Modal from "./components/Modal/Modal";

function App() {
  AOS.init({
    once: false,
    anchorPlacement: "top-bottom",
  });
  const [currentLang, setCurrentLang] = useState("eng");
  const [cookie, setCookie] = useState(true);
  const [modalOn, setModalOn] = useState(false);

  useEffect(() => {
    setModalOn(true);
  }, [currentLang]);

  return (
    <div className="App" style={{ overflow: "hidden" }}>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 7000,
        }}
      />
      {modalOn && (
        <Modal
          setModalOn={setModalOn}
          currentLang={currentLang}
          setCurrentLang={setCurrentLang}
        />
      )}
      <Navbar currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <Header currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <WhatIsDigicall
        currentLang={currentLang}
        setCurrentLang={setCurrentLang}
      />
      <UnileverDigitalTeam
        currentLang={currentLang}
        setCurrentLang={setCurrentLang}
      />
      <WhoCanApply currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <Process currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <Program currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <Faq currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <Register
        modalOn={modalOn}
        setModalOn={setModalOn}
        currentLang={currentLang}
        setCurrentLang={setCurrentLang}
      />
      <Footer currentLang={currentLang} setCurrentLang={setCurrentLang} />
      {cookie && (
        <CookieAnn
          currentLang={currentLang}
          setCurrentLang={setCurrentLang}
          setCookie={setCookie}
        />
      )}
    </div>
  );
}

export default App;
